import { render } from "./withdraw-detail.vue?vue&type=template&id=25b0002c&scoped=true"
import script from "./withdraw-detail.vue?vue&type=script&lang=js"
export * from "./withdraw-detail.vue?vue&type=script&lang=js"

import "./withdraw-detail.vue?vue&type=style&index=0&id=25b0002c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b0002c"]])

export default __exports__